import { z } from 'zod';

import { LiquidationRecordEntry } from '../../loan/LiquidationRecord';
import { BaseLoanEvent } from '../BaseLoanEvent';

export const LiquidateLoanInput = LiquidationRecordEntry.pick({
  method: true,
  dateReceived: true,
  saleProceeds: true,
}).extend({
  principalBalancePayDown: z.number().nonnegative(),
  delinquentInterestPayDown: z.number().nonnegative(),
  pAndIInvestorAdvancePayDown: z.number().nonnegative(),
  escrowAdvancesPayDown: z.number().nonnegative(),
  corporateAdvancesPayDown: z.number().nonnegative(),
  feesPayDown: z.number().nonnegative(),
});
export type LiquidateLoanInput = z.infer<typeof LiquidateLoanInput>;

export const LiquidateLoanEvent = BaseLoanEvent.extend({
  type: z.literal('liquidateLoan'),
  input: LiquidateLoanInput,
});
export type LiquidateLoanEvent = z.infer<typeof LiquidateLoanEvent>;
